var map = {
	"./games/case-battles/jackpot1.mp3": "b3c8",
	"./games/case-battles/jackpot2.mp3": "9b98",
	"./games/case-battles/jackpot3.mp3": "a54e",
	"./games/case-battles/tally1.mp3": "12ba",
	"./games/case-battles/tally2.mp3": "e5ea",
	"./games/case-battles/tally3.mp3": "1b89",
	"./games/case-battles/win-up.mp3": "0219",
	"./games/case-battles/win1.mp3": "73dc",
	"./games/case-battles/win2.mp3": "a34d",
	"./games/case-battles/win3.mp3": "cd8e",
	"./games/cases/big_win.mp3": "f856",
	"./games/cases/dud.mp3": "adb4",
	"./games/cases/land.mp3": "2957",
	"./games/cases/spin.mp3": "25e2",
	"./games/coinflip/glow.mp3": "62a2",
	"./games/coinflip/impact1.mp3": "a937",
	"./games/coinflip/impact2.mp3": "6875",
	"./games/coinflip/impact3.mp3": "a7ff",
	"./games/coinflip/impact4.mp3": "a0bb",
	"./games/coinflip/sheen.mp3": "c5d0",
	"./games/coinflip/toss.mp3": "def4",
	"./games/dice/debris-1.mp3": "d548",
	"./games/dice/debris-2.mp3": "ae98",
	"./games/dice/debris-3.mp3": "ad12",
	"./games/dice/debris-4.mp3": "32e4",
	"./games/dice/explosion-1.mp3": "1bf9",
	"./games/dice/explosion-2.mp3": "f101",
	"./games/dice/fuse.mp3": "6370",
	"./games/dice/impact-1.mp3": "915a",
	"./games/dice/impact-2.mp3": "31d6",
	"./games/dice/impact-3.mp3": "8ee1",
	"./games/dice/impact-4.mp3": "1f42",
	"./games/dice/light.mp3": "115f",
	"./games/dice/throw-1.mp3": "a31f",
	"./games/dice/throw-2.mp3": "e466",
	"./games/dice/throw-3.mp3": "ba0d",
	"./games/wheel/loop.mp3": "8660",
	"./games/wheel/spin.mp3": "c200",
	"./games/wheel/stop1.mp3": "54c4",
	"./games/wheel/stop2.mp3": "6858",
	"./games/wheel/stop3.mp3": "3963",
	"./games/wheel/tick1.mp3": "963d",
	"./games/wheel/tick2.mp3": "fc9e",
	"./games/wheel/tick3.mp3": "090e",
	"./games/wheel/tick4.mp3": "78f0",
	"./games/wheel/win.mp3": "ba37",
	"./items/bone_1.mp3": "1175",
	"./items/bone_2.mp3": "120b",
	"./items/bone_3.mp3": "69d9",
	"./items/bone_4.mp3": "a546",
	"./items/cloth_1.mp3": "a904",
	"./items/cloth_2.mp3": "8c6d",
	"./items/cloth_3.mp3": "e3e8",
	"./items/cloth_4.mp3": "0a28",
	"./items/gun_1.mp3": "0e71",
	"./items/gun_2.mp3": "8ae1",
	"./items/gun_3.mp3": "aa0b",
	"./items/gun_4.mp3": "2cbd",
	"./items/leather_1.mp3": "baab",
	"./items/leather_2.mp3": "c49e",
	"./items/leather_3.mp3": "5bc8",
	"./items/leather_4.mp3": "07ea",
	"./items/metal_1.mp3": "f886",
	"./items/metal_2.mp3": "fd6e",
	"./items/metal_3.mp3": "8b69",
	"./items/metal_4.mp3": "8256",
	"./items/metal_5.mp3": "2852",
	"./items/metal_6.mp3": "d6cd",
	"./items/metal_7.mp3": "e868",
	"./items/metal_8.mp3": "1d71",
	"./items/metal_hollow_1.mp3": "d360",
	"./items/metal_hollow_2.mp3": "a210",
	"./items/metal_hollow_3.mp3": "4b01",
	"./items/metal_hollow_4.mp3": "b0e1",
	"./items/metal_sheet_1.mp3": "ebe7",
	"./items/metal_sheet_2.mp3": "5239",
	"./items/metal_sheet_3.mp3": "ff63",
	"./items/metal_sheet_4.mp3": "a3d5",
	"./items/metal_wood_1.mp3": "7fb3",
	"./items/metal_wood_2.mp3": "8c69",
	"./items/metal_wood_3.mp3": "7e83",
	"./items/metal_wood_4.mp3": "bf53",
	"./items/plastic_1.mp3": "18d5",
	"./items/plastic_2.mp3": "6cd8",
	"./items/plastic_3.mp3": "ca2a",
	"./items/plastic_4.mp3": "1f82",
	"./items/rubber_1.mp3": "158e",
	"./items/rubber_2.mp3": "431c",
	"./items/rubber_3.mp3": "dec6",
	"./items/rubber_4.mp3": "f967",
	"./items/stone_1.mp3": "ecc1",
	"./items/stone_2.mp3": "76ee",
	"./items/stone_3.mp3": "9c7a",
	"./items/stone_4.mp3": "a65f",
	"./items/wood_1.mp3": "b350",
	"./items/wood_2.mp3": "d3cc",
	"./items/wood_3.mp3": "6959",
	"./items/wood_4.mp3": "b7cb",
	"./items/wood_5.mp3": "9e84",
	"./items/wood_6.mp3": "6615",
	"./items/wood_7.mp3": "4170",
	"./items/wood_8.mp3": "2c73",
	"./level_up.mp3": "fe79",
	"./toast-error.mp3": "24bc",
	"./toast-info.mp3": "82129",
	"./toast-success.mp3": "91e3",
	"./toast-warning.mp3": "dfe6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba5b";